import { useCallback, useRef, useState } from 'react';

import './Dropdown.scss';
import { useOnClickOutside } from "../clickoutside/useClickOutsideHook";
import PropTypes from "prop-types";

const Dropdown = ({onChange, label, items, selectedText}) => {
    const [showItems, setShowItems] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const ref = useRef(null);

    const outsideClickHandler = useCallback(
        () => setShowItems(false),
        []
    );
    useOnClickOutside(ref, outsideClickHandler);

    const handleChangeSelectedItem = selectedItem => () => {
        setSelectedItem(selectedItem);
        setShowItems(false);
        onChange(selectedItem);
    }

    const toggleDropdown = () => {
        setShowItems(!showItems);
    }

    const dropdownListCls = `dropdown-input-list ${showItems ? 'dropdown-input-list--visible' : ''}`;
    const dropdownItemCls = `dropdown-input-list-item ${showItems ? 'dropdown-input-list-item--visible' : ''}`;
    const dropdownArrowCls = `dropdown-input-label-arrow ${showItems ? 'dropdown-input-label-arrow--up' : ''}`;
    let labelText = selectedText || '';
    if (selectedItem) {
        labelText = selectedItem.text;
    } else if (!labelText && label) {
        labelText = label;
    }
    const itemsToRender = items.filter(el => el.text !== labelText);
    return (
        <div
            className="dropdown-input"
            ref={ref}
        >
            <div
                className="dropdown-input-label"
                onClick={toggleDropdown}
            >
                <span>{labelText}</span>
                <span className={dropdownArrowCls}/>
            </div>
            <div className={dropdownListCls}>
                {itemsToRender.map(el => (
                    <div
                        onClick={handleChangeSelectedItem(el)}
                        className={dropdownItemCls}
                        key={el.key}
                    >
                        {el.text}
                    </div>
                ))}
            </div>
        </div>
    );
}

Dropdown.propTypes = {
    items: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedText: PropTypes.string,
    label: PropTypes.string
}

export default Dropdown;